import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import AdPlaceholder from '../AdPlaceholder';
import './Layout.css';

export function Layout() {
  return (
    <div className="layout">
      <Header />
      <div className="layout-body">
        <aside className="layout-sidebar">
          <Sidebar />
        </aside>
        <main className="layout-main">
          <Outlet />
        </main>
      </div>
      <Footer />
      <div className="layout-mobile-ad" aria-hidden="true">
        <AdPlaceholder variant="mobile-sticky" />
      </div>
    </div>
  );
}
